export default __webpack_public_path__ + "static/media/3.90d0c453.jpeg";